import MetaHead from '@/Components/MetaHead';
export default function RefundPolicy() {
  return (
    <>
      <MetaHead title="Refund Policy | Fyllo" />
      <section className="bg-white ">
        <div className="mx-12 md:mx-56 py-12 text-center">
          <h1 className="mb-4 text-4xl font-extrabold tracking-tight leading-none  text-fyllo-800 md:text-5xl lg:text-4xl ">
            Our Refund Policy
          </h1>
          <p>Last updated: March 23, 2023</p>
          <div className="mb-8 text-lg text-start font-normal text-gray-500 lg:text-xl sm:px-16 xl:px-48 pt-5 ">
            Thank you for shopping at Fyllo. If, for any reason, You are not completely satisfied with a purchase We
            invite You to review our policy on refunds and returns. The following terms are applicable for any products
            that You purchased with Us.
            <h2 className="my-4 text-xl font-semibold  text-gray-900 md:text-2xl lg:text-3xl ">
              Interpretation and Definitions
            </h2>
            <h3 className="my-1 text font-semibold  text-gray-900 md:text-lg lg:text-2xl ">Interpretation</h3>
            The words of which the initial letter is capitalized have meanings defined under the following conditions.
            The following definitions shall have the same meaning regardless of whether they appear in singular or in
            plural.
            <h3 className="my-3 text font-semibold  text-gray-900 md:text-lg lg:text-2xl ">Definitions</h3>
            For the purposes of this Return and Refund Policy:
            <ul className="text-gray-500 list-disc p-5 flex flex-col gap-2">
              <li className="text-gray-500">
                <strong>Application</strong> means the software program provided by the Company downloaded by You on any
                electronic device, named Fyllo
              </li>
              <li className="text-gray-500">
                <strong>Company</strong> (referred to as either &quot;the Company&quot;, &quot;We&quot;, &quot;Us&quot;
                or &quot;Our&quot; in this Agreement) refers to Agrihawk Technologies Pvt. Ltd., 24th Main Road, HSR
                Layout, Sector 2 523, 2nd floor Bengaluru South, Karnataka 560102, IN.
              </li>
              <li className="text-gray-500">
                <strong>Goods</strong> refer to the items offered for sale on the Service.
              </li>
              <li className="text-gray-500">
                <strong>Orders</strong> mean a request by You to purchase Goods from Us.
              </li>
              <li className="text-gray-500">
                {' '}
                <strong>Service</strong> refers to the Application.
              </li>
              <li className="text-gray-500">
                <strong>You</strong> means the individual accessing or using the Service, or the company, or other legal
                entity on behalf of which such individual is accessing or using the Service, as applicable.
              </li>
            </ul>
            <h3 className="my-3 text font-semibold  text-gray-900 md:text-lg lg:text-2xl ">
              Your Order Cancellation Rights
            </h3>
            Once a purchase has been made, it cannot be refunded. We only offer refunds in cases of damaged or faulty
            products upon receipt. If you receive a damaged or faulty product, please contact us within 7 days of
            receipt, and we will arrange a return and refund or exchange
            <br />
            <br />
            In order to exercise Your right of cancellation, You must inform Us of your decision by means of a clear
            statement. You can inform us of your decision by:
            <br />
            By email: support@fyllo,in
            <h3 className="my-3 text font-semibold  text-gray-900 md:text-lg lg:text-2xl ">Contact Us</h3>
            If you have any questions about our Returns and Refunds Policy, please contact us:
            <br />
            By email: support@fyllo,in
          </div>
        </div>
      </section>
    </>
  );
}
